module.exports = __webpack_public_path__ + "img/computing.62b9d3f8.png";